import React from 'react';
import styles from './index.module.less';
import { useTranslation } from '@/modules/ReoI18n';
import { ReoIcon } from '@reolink-web/components.basic';
import { getOfficialSitePath } from '@/utils/function/sitePath';
const CompFourInput: React.FC = React.memo(() => {
    const { t } = useTranslation();
    const [searchText, setSearchText] = React.useState('');
    const onSearchIconClick = React.useCallback(() => {
        if (searchText) {
            try {
                window?.open(getOfficialSitePath(`/sitesearch/?q=${searchText}`));
            }
            catch (e) {
                console.error(e);
            }
        }
    }, [searchText]);
    return (
        <div className={ `${styles['four-input-content']} text-center` }>
            <div className={ styles['four-input-div'] }>{t('page-not-found:page-not-found')}</div>
            <input
                value={ searchText }
                type="text"
                className={ styles['four-input'] }
                placeholder={ t('page-not-found:try-to-search') }
                onChange={ (res) => {
                    setSearchText(res.target.value);
                } }
            />
            <ReoIcon
                className={ `${styles['error-search']}` }
                name={ 'icon-icon_search-2' }
                // eslint-disable-next-line react/jsx-handler-names
                onClick={ onSearchIconClick }
            ></ReoIcon>
        </div>
    );
});
export default CompFourInput;
